import { createSelector, createSlice } from '@reduxjs/toolkit'
import { normalizeExtrasToAttractions } from '../../utils/checkout'

const initialState = {
  checkout: {
    tours: [],
    travelers: {
      mainPasseger: {},
      others: []
    }
  }
}

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    saveMainPassenger: (state, action) => {
      state.checkout.travelers.mainPasseger = action.payload;
    },
    add: (state, action) => {
      console.log('depredated');
      //state.tours.push(action.payload);
    },
    addTour: (state, action) => {
      const tours = JSON.parse(JSON.stringify(state.checkout.tours));
      const tour = tours.find(tour => tour.slug === action.payload.slug);
      if (tour) {
        const updatedTours = tours.map(t => {

          if (t.slug === action.payload.slug) {
            if (t.date !== action.payload.date) {
              t.date = action.payload.date;
            }

            // prefer attractions but accept legacy activities using normalizer
            const payloadExtrasList = normalizeExtrasToAttractions(action.payload.extras || {});
            if (payloadExtrasList.length > 0) {
              // store canonical list under options.selectedAttractions
              t.options = t.options || {};
              t.options.selectedAttractions = payloadExtrasList;
            } else {
              // keep existing selectedAttractions if payload didn't provide any
              t.options = t.options || {};
              t.options.selectedAttractions = t.options.selectedAttractions || (Array.isArray(t.extras?.activities) ? t.extras.activities : (t.extras?.attractions || []));
            }

            // ensure payload carries options.selectedAttractions so callers like prePrareTourBookingData can read it
            action.payload.options = action.payload.options || {};
            action.payload.options.selectedAttractions = t.options.selectedAttractions;

            // update pricedOptions if provided in payload (merge/replace)
            if (action.payload.pricedOptions && Array.isArray(action.payload.pricedOptions)) {
              t.pricedOptions = action.payload.pricedOptions;
              t.customizations = t.customizations || {};
              t.customizations.pricedOptions = action.payload.pricedOptions;
            }

            return { ...t, ...action.payload };
          }
          return t;
        });
        state.checkout.tours = updatedTours;

      } else {
        state.checkout.tours.push(action.payload)
      }
    },
    remove: (state, action) => {
      state.checkout.tours = state.checkout.tours.filter(tour => tour.slug !== action.payload)
    },
    setAssitants: (state, action) => {
      console.log('depredated');
      //state.assistants = action.payload;
    },
    removeExtraActivities: (state, action) => {
      const stateCheckout = JSON.parse(JSON.stringify(state));
      const { checkout: { tours } } = stateCheckout;
      const { url } = action.payload;

      const newTours = tours.map((tour, index) => {
        if (tour.slug === url) {
          // ensure options exists and store normalized list under options.selectedAttractions
          tour.options = tour.options || {};
          const payloadList = normalizeExtrasToAttractions(action.payload.extras || {});
          tour.options.selectedAttractions = payloadList;
          return tour;

          // const newActivities = tour['extras']['activities'].filter(activity => activity.name !== action.payload.extras.name);
          // console.log('newActivities', newActivities);
          // tour['extras']['activities'] = newActivities;
          // return tour;
        }
        return tour
      });

      state.checkout.tours = newTours;
    },
    setExtraActivities: (state, action) => {

      const stateCheckout = JSON.parse(JSON.stringify(state));
      const { checkout: { tours } } = stateCheckout;
      const { url } = action.payload;
      let extraWasAdded = false;


      const newTours = tours.map((tour, index) => {
        if (tour.slug === url) {
          // ensure options exists and store normalized list under options.selectedAttractions
          tour.options = tour.options || {};
          const payloadList = normalizeExtrasToAttractions(action.payload.extras || {});
          tour.options.selectedAttractions = payloadList;

          extraWasAdded = true;
          return tour;
        }
        return tour
      });


      if (!extraWasAdded) {
        const newTour = action.payload;
        newTour['extras'] = newTour['extras'] || {};
        // migrate payload extras into options.selectedAttractions (also keep activities for compatibility)
        const payloadList = normalizeExtrasToAttractions(action.payload.extras || {});
        newTour.options = newTour.options || {};
        newTour.options.selectedAttractions = payloadList;
        newTours.push(newTour.tourData);
        console.log(newTours);
      }

      state.checkout.tours = newTours;

    },
    emptyCart: (state) => {
      state.checkout.tours = [];
      state.checkout.travelers.mainPasseger = {};
    }
  },
})

export const { add, remove, addTour, setAssitants, saveMainPassenger, emptyCart, setExtraActivities, removeExtraActivities } = cartSlice.actions

export const selectTours = (state) => state.cart.tours;

export const totalPrice = (state) => state.cart.checkout.tours.reduce((acc, item) => acc + item.total, 0);
export const selectCartItems = (state) => state?.cart?.checkout?.tours;

export const selectTotalPrice = createSelector(
  [selectCartItems],
  (items) =>
    items?.reduce((total, item) => {
      let totalByActivity = 0;
      const subTotal = item.booking.reduce((sum, b) => sum + (b.price * b.value), 0);

      // prefer canonical list in options.selectedAttractions, fallback to extras.attractions or legacy activities
      const extrasList = item.options?.selectedAttractions || item.extras?.attractions || item.extras?.activities || [];
      if (extrasList.length > 0) {
        const paxes = item.booking.map(pax => ({
          name: pax.title,
          value: pax.value
        }));

        extrasList.forEach(activity => {
          activity.rates?.forEach(rate => {
            const pax = paxes.find(pax => pax.name === rate.pax);
            if (pax) {
              totalByActivity += rate.price * pax.value;
            }
          });
        });
      }

      // include pricedOptions from either item.pricedOptions or item.customizations.pricedOptions
      let optionsCost = 0;
      try {
        const opts = item.pricedOptions || item.customizations?.pricedOptions || [];
        optionsCost = opts.reduce((s, o) => s + (Number(o.price) || 0), 0);
      } catch (e) { optionsCost = 0 }

      const itemTotal = subTotal + totalByActivity + optionsCost;
      // Suma el total acumulado
      return total + (item?.iva > 0 ? itemTotal + Math.ceil(itemTotal * (item?.iva / 100)) : itemTotal);
    }, 0)
);


export const selectProductTotal = createSelector(
  // Input selectors
  [selectCartItems, (state, name) => name],
  // Función de cálculo
  (items, name) => {
    const product = items.find((item) => item.name === name);
    let totalByActivity = 0;
    if (!product) return 0;
    const subTotal = product.booking.reduce((total, item) => (item.price * item.value), 0);

    const productExtrasList = product.options?.selectedAttractions || product.extras?.attractions || product.extras?.activities || [];
    if (productExtrasList.length > 0) {
      const paxes = product.booking.map(pax => ({ name: pax.title, value: pax.value }));
      productExtrasList.forEach(activity => {
        activity.rates?.forEach(rate => {
          const pax = paxes.find(pax => pax.name === rate.pax);
          if (pax) {
            totalByActivity += rate.price * pax.value;
          }
        });
      });
    }

    //const customizationsCost = product.customizations.reduce((sum, c) => sum + c.price, 0);
    // include pricedOptions in product total
    let optionsCost = 0;
    try {
      const opts = product.pricedOptions || product.customizations?.pricedOptions || [];
      optionsCost = opts.reduce((s, o) => s + (Number(o.price) || 0), 0);
    } catch (e) { optionsCost = 0 }

    const itemTotal = subTotal + totalByActivity + optionsCost;
    return product?.iva > 0 ? itemTotal + Math.ceil(itemTotal * (product?.iva / 100)) : itemTotal;
  }
);

export const selectAssitants = (state) => state.cart.assistants;

export default cartSlice.reducer
